<style lang="less" scoped>
ul,li {margin: 0;padding: 0;list-style: none;}
.hyzx {position: relative;width: 100%;margin: 0;padding: 0;background: #fff;font-family: AlibabaPuHuiTi-Medium;min-height: 456px;}
.container {width: 1200px;margin: 0px auto;}
/deep/.el-tabs__item {line-height: 62px !important;width: 170px;height: 62px;text-align: center !important;	line-height: 32px;letter-spacing: 1px;color: #000000;font-size: 18px;}
/deep/.is-active {background-color: #0090ff;color: #ffffff;}
/deep/#tab-second {border-top: solid 1px #707070;}
/deep/ .el-tabs--left .el-tabs__nav-wrap.is-left::after, .el-tabs--left .el-tabs__nav-wrap.is-right::after, .el-tabs--right .el-tabs__nav-wrap.is-left::after, .el-tabs--right .el-tabs__nav-wrap.is-right::after {width: 0;}
/deep/.el-tabs--left .el-tabs__active-bar.is-left, .el-tabs--left .el-tabs__active-bar.is-right, .el-tabs--right .el-tabs__active-bar.is-left, .el-tabs--right .el-tabs__active-bar.is-righ {width: 0;}
.v-modal {z-index:0 !important}
</style>

<template>
  <div class="hyzx">
    <div class="container">
      <Navigation v-if="this.isMobile()" :navigationdatas="navigationdatasApp" class="navigation"></Navigation>
      <Navigation v-else :navigationdatas="navigationdatas" class="navigation"></Navigation>
      <el-tabs v-model="activeName" :tab-position="tabPosition" :before-leave='Tabever'>
        <el-tab-pane label="会员中心" name="1">
          <Information></Information>
        </el-tab-pane>
        <el-tab-pane label="修改密码" name="2">
          <Password></Password>
        </el-tab-pane>
        <el-tab-pane label="咨询管理" name="3">
          <Zxgl :userData='userData'></Zxgl>
        </el-tab-pane>
        <el-tab-pane label="法律管理" name="4">
          <Flgl :userData='userData'></Flgl>
        </el-tab-pane>
        <el-tab-pane label="参会管理" name="5">
          <Chxx :userData='userData'></Chxx>
        </el-tab-pane>
        <el-tab-pane label="企业信息" name="6" v-if='isqyuser === true'>
          <Qyxx :userData='userData'></Qyxx>
        </el-tab-pane>
        <el-tab-pane label="个人产品" name="7" v-if='isgruser === true'>
          <GrQyxx :userData='userData'></GrQyxx>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Navigation from '../assembly/Navigation.vue'
import Information from '../assembly/hyxx/Information.vue'
import Password from '../assembly/hyxx/Password.vue'
import Zxgl from '../assembly/zxxx/ZX/Zxgl.vue'
import Flgl from '../assembly/zxxx/FL/Flgl.vue'
import Chxx from '../assembly/chxx/Chxx.vue'
import Qyxx from '../assembly/qyxx/Qyxx.vue'
import GrQyxx from '../assembly/qyxx/GrQyxx.vue'
export default {
  beforeRouteEnter(to, from, next)
  {
    next((vm) =>
    {
      if (!localStorage.getItem('username'))
      {
        vm.$message(
          {
            message: '请您先登录',
            type: 'error',
            customClass: 'mzindex'
          }
        )
        vm.$router.push('/loginIndex')//拦截成功后需要跳转的页面
      }
    })
  },
  components: {
    Navigation,
    Information,
    Password,
    Zxgl,
    Flgl,
    Chxx,
    Qyxx,
    GrQyxx
  },
  data()
  {
    return {
      navigationdatas: [
        {
          theme: '首页',
          path: '/Kyforum'
        },
        {
          theme: '会员中心',
          path: ''
        }
      ],
      navigationdatasApp: [
        {
          theme: '首页',
          path: '/KyforumApp'
        },
        {
          theme: '会员中心',
          path: ''
        }
      ],
      activeName: '1',
      tabPosition: 'left',
      isgruser: false,  // 是否是个人用户
      isqyuser: false,  // 是否是企业用户
      iszjuser: false,  // 是否是专家
      userData: {}  // 用户信息数据
    }
  },
  async created()
  {
    if (localStorage.getItem('username'))
      this.getUser(localStorage.getItem('username'))
  },
  methods: {
    getUser(username)
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 28,
        _exp: `username = '${username}'`
      }
      window.post.getPost(paras).then((ret) =>
      {
        if (ret[0].groupid === '5')
        {
          this.isgruser = true
          this.isqyuser = false
          this.iszjuser = false
        }
        else if (ret[0].groupid === '6')
        {
          this.isgruser = false
          this.isqyuser = true
          this.iszjuser = false
        }
        else if (ret[0].groupid === '8')
        {
          this.isgruser = false
          this.isqyuser = false
          this.iszjuser = true
        }
        this.userData = ret[0]
        window.userData = ret[0]
      })
    },
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '3')
        this.$store.commit('onIsLb', '1')
      if (activeName === '4')
        this.$store.commit('onIsLb', '1')
      if (activeName === '5')
        this.$store.commit('onIsLb', '1')
      if (activeName === '6')
        this.$store.commit('onIsLb', '1')
    },
    // 用户设备的判断
    isMobile()
    {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/project/Members.vue